import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/shadcn/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { ScrollArea } from "@/shadcn/components/ui/scroll-area";
import { cn } from "@/shadcn/lib/utils";

import { Check, ChevronsUpDown } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";

type SimpleTask = {
  id: number;
  name: string;
};

type TaskPickerProps = {
  type: "User" | "Precache";
  taskID: number | null;
  handleFieldTask: (id: number) => void;
  align?: "start" | "end" | "center" | undefined;
  side?: "bottom" | "left" | "right" | "top" | undefined;
  triggerButtonClassName?: string;
  triggerContainerClassName?: string;
};

const TaskPicker: React.FC<TaskPickerProps> = ({
  type,
  taskID,
  handleFieldTask,
  side,
  align,
  triggerButtonClassName,
  triggerContainerClassName,
}) => {
  const { precacheTasks, userTasks } = useContext(AppContext);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [tasks, setTasks] = useState<SimpleTask[]>([]);

  useEffect(() => {
    if (type === "User") {
      // Get name + id from userTasks
      const userTaskList = userTasks.map((task) => ({
        id: task.id,
        name: task.title,
      }));
      setTasks(userTaskList);
    }

    if (type === "Precache" && precacheTasks) {
      // Get name + id from precacheTasks
      const precacheTaskList = precacheTasks.map((task) => ({
        id: task.id,
        name: task.title,
      }));
      setTasks(precacheTaskList);
    }
  }, [precacheTasks, type, userTasks]);

  useEffect(() => {
    console.log("tasks", tasks);
    console.log("taskID", taskID);
    console.log("taskID", typeof taskID);
  }, [taskID, tasks]);

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen} modal={true}>
      <PopoverTrigger
        className="w-full"
        onClick={(e) => {
          e.stopPropagation();
          setIsPopoverOpen(true);
        }}
        asChild
      >
        <div
          id="edit-task"
          className={cn(
            `ps-0 flex flex-row items-center justify-between w-full text-left`,
            triggerContainerClassName
          )}
          // className="ps-0 flex flex-row items-center justify-between w-full text-left"
        >
          <Button
            className={cn(
              `truncate w-full justify-between max-w-[250px]`,
              triggerButtonClassName
            )}
            variant="outline"
            role="combobox"
          >
            <span className="truncate max-w-full">
              {taskID
                ? tasks.find((task) => task.id === taskID)?.name
                : "Select a task"}
            </span>
            <ChevronsUpDown className="ml-3 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent className="max-w-[250px] p-0" align={align} side={side}>
        <Command>
          <CommandInput placeholder="Search task..." />
          <CommandList>
            <ScrollArea className="h-[200px] overflow-y-auto">
              <CommandEmpty>No tasks found.</CommandEmpty>
              <CommandGroup>
                {tasks.map((task) => (
                  <div key={task.id} onMouseDown={(e) => e.stopPropagation()}>
                    <CommandItem
                      onSelect={() => {
                        handleFieldTask(task.id);
                        setIsPopoverOpen(false);
                      }}
                    >
                      <Check
                        className={`mr-2 h-4 w-4 ${
                          taskID === task.id ? "opacity-100" : "opacity-0"
                        }`}
                      />
                      {task.name}
                    </CommandItem>
                  </div>
                ))}
              </CommandGroup>
            </ScrollArea>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default TaskPicker;
